import React from "react";
import ChangePageTitle from "../components/change-title-page";
import Contact_components from "../components/components-contact";

function Contact(){

    return(
        <>
            <ChangePageTitle pageTitle="تماس با ما | رستوران باغبان" />
            <Contact_components />
        </>
    );

}

export default Contact;